import * as React from 'react';
import { LicenseManager } from 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import AdminConfig from "@system/config/admin";
import Constants from 'src/support/Constants';
LicenseManager.setLicenseKey("Using_this_{AG_Charts_and_AG_Grid}_Enterprise_key_{AG-076353}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Avnet,_Inc.}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Charts_and_AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Charts_and_AG_Grid}_Enterprise_versions_released_before_{8_April_2026}____[v3]_[0102]_MTc3NTYwMjgwMDAwMA==3018d0b5d5bf8c9157a79b1cae7a1968");

const AdminConsoleHeader = (props) => {
    const { title, tab } = props;

    const redirectUserConsol = () => {
        if (title.includes("BOM")) {
            if (title !== "BOM MANAGEMENT") {
                window.location.href = AdminConfig.getAdminBOMManagementURL();
            }
        } else {
            if (tab !== Constants.adminConsoleTab.User) {
                window.location.href = AdminConfig.getAdminUserManagementURL();
            }
        }
    }

    return (
        <>
            <div className='container'>
                <div className="adminconsole-head header-container d-flex align-items-center justify-content-between">
                    <div className={`page-title font-oswald font-light font-38 text-green ${(tab === Constants.adminConsoleTab.User || title === "BOM MANAGEMENT") ? 'cursor-default' : 'cursor-pointer'}`} onClick={() => redirectUserConsol()}>Admin Console</div>
                </div>
                <div className="pcn-line-divider"></div>
                <div className="page-title font-oswald font-light font-30">{title}</div>
            </div>
        </>
    );
}

export default AdminConsoleHeader;